import React from 'react';
import { View } from '@amzn/stencil-react-components/layout';
import { Button } from '@amzn/stencil-react-components/button';
import { ScreenReaderOnly } from '@amzn/stencil-react-components/screen-reader-only';

interface ConsentFooterProps {
  onSubmit: () => void;
  isSubmitDisabled?: boolean;
  isLoading?: boolean;
  submitText?: string;
}

export const ConsentFooter: React.FC<ConsentFooterProps> = ({
  onSubmit,
  isSubmitDisabled = false,
  isLoading = false,
  submitText = 'Submit'
}) => {
  return (
    <View style={{
      width: '100%',
      backgroundColor: 'white',
      borderTop: '1px solid #e0e0e0',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
      padding: '1.5rem 0',
      marginTop: 'auto',
      position: 'sticky',
      bottom: 0,
      zIndex: 50
    }}>
      <View style={{ 
        maxWidth: '1200px', 
        padding: '0 2rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '2rem',
        paddingLeft: '7rem'
      }}>
        {/* Hidden helper text for screen readers */}
        <ScreenReaderOnly id="submit-help-text">
          {isLoading 
            ? "Your consent decision is being processed. Please wait." 
            : "Submit your consent decision to complete the process."
          }
        </ScreenReaderOnly>

        <Button 
          onClick={onSubmit}
          disabled={isSubmitDisabled || isLoading}
          aria-label={isLoading ? "Processing consent submission" : "Submit consent decision"}
          aria-describedby="submit-help-text"
          style={{ 
            backgroundColor: '#2563EB',
            color: 'white',
            padding: '0.75rem 2rem',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: (isSubmitDisabled || isLoading) ? 'not-allowed' : 'pointer',
            opacity: (isSubmitDisabled || isLoading) ? 0.5 : 1
          }}
        >
          {isLoading ? (
            <span role="status" aria-live="polite">
              Processing...
            </span>
          ) : (
            submitText
          )}
        </Button>
      </View>
    </View>
  );
};

export default ConsentFooter;
